import { useState, useEffect } from "react";
import { Button } from "../../components/ui/button";
import { useToast } from "../../components/ui/use-toast";
import { DirectSale, useDeleteDirectSale } from "@/lib/api/directSales";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { formatCommodityToUom, formatNumberToDisplay } from "../../lib/api/common";

export function ConfirmDeleteModal({ directSale, onDeleted }: { directSale?: DirectSale; onDeleted: any }) {
  const { toast } = useToast();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const deleteDirectSale = useDeleteDirectSale();

  useEffect(() => {
    if (isOpen && !directSale) {
      setIsOpen(false);
      setIsDeleting(false);
    }
    if (!isOpen && directSale) {
      setIsOpen(true);
    }
  }, [isOpen, directSale])

  const onDelete = async (e: any) => {
    if (e?.preventDefault) { e.preventDefault(); }
    if (!directSale?.id) { return; }
    if (isDeleting) { return; }
    setIsDeleting(true);

    try {
      const result = await deleteDirectSale({ id: directSale!.id });
      if (!result.success) {
        throw result;
      }

      toast({
        title: "Deleted"
      })
      onDeleted(false);
      setIsOpen(false);
    } catch (error) {
      console.error("Failed to delete staged data", error);
      toast({
        title: "Failed to delete"
      })
    } finally {
      setIsDeleting(false);
    }
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(status) => {
        onDeleted(status);
        setIsOpen(false);
      }}
    >
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto lg:max-w-5xl xl:max-w-6xl">
        <DialogHeader>
          <DialogTitle>
            Delete Row
          </DialogTitle>
        </DialogHeader>

        <div className="grid ">
          {directSale && (
            <Card>
              <CardContent className="space-y-2 flex flex-col lg:grid lg:grid-cols-3 w-full">
                <div className="mt-4">
                  <Label className="font-semibold">Producer</Label>
                  <p>{directSale?.Producer?.long_name}</p>
                </div>
                <div>
                  <Label className="font-semibold">Commodity</Label>
                  <p>{directSale.commodity}</p>
                </div>
                <div>
                  <Label className="font-semibold">Quantity</Label>
                  <p>{formatNumberToDisplay(directSale.qty, { emptyFormat: "--", zeroFormat: "--", suffix: formatCommodityToUom(directSale.commodity) })}</p>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        <form className="flex flex-col gap-4" onSubmit={onDelete}>
          <Button type="submit" disabled={isDeleting}>{isDeleting ? "Deleting..." : "Confirm"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
